import React, { Component } from 'react';
import { Container, Tabs, Tab, Row, Col, Button, ButtonToolbar, Table } from 'react-bootstrap';
import { FaFile, FaFileAlt, FaFolderOpen } from 'react-icons/fa';
import UploadResultFiles from './UploadResultFiles'
import Header from '../../components/header';
import { Question, FileRecord } from '../../services/Learning';
import Courses, { Course, ScenarioLearningStatus, ScenarioLearningStatusString, UserGroupMark, FinalGroupMark, CaseUserAssignment } from '../../services/CoursesService';
import ChatService, { ChatMessage, ChatServiceStatus } from '../../services/ChatService';
import { Redirect } from 'react-router';
import { AppRoute } from '../../definitions/routes';
import Utils from '../../services/Utils';
import MarkForm from './MarkForm';
//import Question from '../cases/Question';

// import demoQuestions from './demo-data/questions';

const Launcher = require('../../components/react-chat-window/es').Launcher;

type GroupTestingProps = {
    assignmentId: number
}

type GroupTestingState = {
    isCourseLoaded: boolean,
    redirectToCourses: boolean,
    currentQuestionIndex: 0,
    totalQuestions: 0,
    questions: [],
    assignedMarks: Array<UserGroupMark>,
    currentQuestion?: Question,
    messages: Array<any>,
    chatContacts: Array<{name: string, email: string}>,
    course?: Course,
    groupId: number,
    courseName: string,
    courseMaterials: {fileRecord: { id: number, originalFileName: string }, name: string}[],
    isResultUploader: boolean,
    learningStatus: ScenarioLearningStatusString,
    isOpenChatWindow: boolean,
    chatMessageUnreadCount: number,
    finalMark?: FinalGroupMark,
    currentAssignment?: CaseUserAssignment,
    finalGroupMarks: FinalGroupMark[]
}

class GroupTesting extends Component<GroupTestingProps, GroupTestingState> {
    
    uploadResultFiles = null as UploadResultFiles | null;
    chatService = null as ChatService | null;
    markForm = null as MarkForm | null;
    
    constructor(props: GroupTestingProps) {
        super(props);

        this.state = {
            isCourseLoaded: false,
            redirectToCourses: false,
            currentQuestionIndex: 0,
            totalQuestions: 0,
            questions: [],
            currentQuestion: undefined,
            messages: [],
            chatContacts: [],
            course: undefined,
            assignedMarks: [],
            groupId: 0,
            courseName: '',
            courseMaterials: [],
            isResultUploader: false,
            learningStatus: ScenarioLearningStatusString.UNDEFINED,
            isOpenChatWindow: false,
            chatMessageUnreadCount: 0,
            finalGroupMarks: []
        };
        
        // this.logout = this.logout.bind(this);
    }
    
    // logout() {
    //     logout();
    //     if (this.props.onLogout) {
    //         this.props.onLogout();
    //     }
    // }

    async componentDidMount() {
        const currentAssignment = await Courses.getAssignmentById(this.props.assignmentId);

        if (currentAssignment == undefined){
            this.setState({isCourseLoaded: true});
        } else {
            this.chatService = new ChatService(currentAssignment.course.id as number, (messages: Array<ChatMessage>) => this.onReceiveNewChatMessage(messages));
            this.chatService.start();
            const chatContacts = (await this.chatService.getContacts()).data.map(m => ({name: m.firstName, email: m.email}));
            const assignedMarks = await Courses.getAssignedMarks(this.props.assignmentId);
            let finalMark = undefined;
            let finalGroupMarks = [] as FinalGroupMark[];
            if ((currentAssignment.status as any) == ScenarioLearningStatusString.FINISHED) {
                finalMark = await Courses.getFinalGroupMark(currentAssignment.course.id as number, currentAssignment.group);
                finalGroupMarks = await Courses.getFinalGroupMarks(currentAssignment.course.id as number);
            }
            this.setState({
                isCourseLoaded: true,
                groupId: currentAssignment.group,
                course: currentAssignment.course,
                courseName: `${currentAssignment.course.name}`,
                courseMaterials: currentAssignment.course.openCourseMaterials,
                isResultUploader: currentAssignment.isResultUploader,
                learningStatus: currentAssignment.status as any,
                chatContacts,
                assignedMarks,
                finalMark,
                finalGroupMarks,
                currentAssignment
            });
        }

        // UserDetailsService.loadUserDetails()
        // .then(({firstName, lastName}) => {
        //     this.setState({
        //         fullName: firstName + ' ' + lastName
        //     });
        // });

        // let questions = demoQuestions;        
        // this.setState({
        //     totalQuestions: questions.length,
        //     questions: questions,
        //     currentQuestionIndex: 0,
        //     currentQuestion: questions[0]
        // });
    }

    componentWillMount() {

    }

    componentWillUnmount() {
        if (this.chatService && this.chatService.getServiceStatus() == ChatServiceStatus.STARTED){
            this.chatService.stop();
        }
    }

    prepareChatMessages(messages: Array<ChatMessage>){
        return messages.map(m => ({
            author: m.isMyMessage ? 'me' : m.user.firstName,
            data: {text: m.message},
            type: "text"
        }));
    }

    onReceiveNewChatMessage(messages: Array<ChatMessage>){
        const prepareMessages = this.prepareChatMessages(messages);
        const chatMessageUnreadCount = this.state.isOpenChatWindow ? 0 : (this.state.chatMessageUnreadCount + messages.length);
        this.setState({messages: this.state.messages.concat(prepareMessages), chatMessageUnreadCount});
    }

    onPreviousQuestion = () => {
        if (this.state.currentQuestionIndex > 0) {
            this.loadQuestion(this.state.currentQuestionIndex - 1);
        }
    }

    onNextQuestion = () => {
        if (this.state.currentQuestionIndex < this.state.totalQuestions) {
            this.loadQuestion(this.state.currentQuestionIndex + 1);
        }
    }

    loadQuestion = (questionIndex: number) => {
        // this.setState({
        //     currentQuestionIndex: questionIndex,
        //     currentQuestion: this.state.questions[questionIndex]
        // });
    }

    // onSettingsClick = (dialogData) => {
        /*DataProvider.executeAction('settings', 'read', {}).then((res)=>{
            DialogService.showDialog(EditSettingsForm, res.data[0]).then(result =>{
                if(result.dialogResult === DialogResult.ok) {
                    console.log("edit settings step 1 success", result);
                } else {
                    console.log("edit settings step 1 reject", result);
                }            
            });
        });
        */
    // }

    async _onMessageWasSent(message: any) {
        if (this.chatService) await this.chatService.sendMessage(message.data.text);
    }

    onPressChatLauncher(){
        const isOpenChatWindow = !this.state.isOpenChatWindow;
        const chatMessageUnreadCount = isOpenChatWindow ? 0 : this.state.chatMessageUnreadCount;
        this.setState({isOpenChatWindow, chatMessageUnreadCount});
    }

    async onScrollMessageListToTop(){
        if (!this.chatService) return;
        const messages = await this.chatService.loadOldMessages();
        if (messages.length > 0){
            const prepareMessages = this.prepareChatMessages(messages);
            this.setState({messages: prepareMessages.concat(this.state.messages)});
        }
    }

    renderCourseMaterials(){
        const materials = this.state.courseMaterials ? this.state.courseMaterials : [];
        return (
            <Row>
                {materials.map((material, index: number) => (
                    <Col xs={3} style={{textAlign: 'center'}} title={material.name} key={index} >
                        <a download={material.fileRecord.originalFileName} href={Utils.getFileUrl(material.fileRecord) as any} title={material.name} target={"_blank"}>
                            <div><FaFileAlt style={{fontSize: '3em', color: 'lightskyblue'}} /></div>
                            <div style={{overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}><span>{material.name}</span></div>
                        </a>
                    </Col>
                ))}
            </Row>
        );
    }

    onPressLoadResultMaterial(){
        if (this.uploadResultFiles == null) return;
        this.uploadResultFiles.open();
    }

    openMarkForm = (mark: UserGroupMark) => {
        if (this.markForm != null) {
            this.markForm.open(mark);
        }
    }

    renderCourse(){
        //this.state.learningStatus.toString() === 'STARTED'
        return (
            <>
                <h1>{'Задание на выполнение'}</h1>
                <div dangerouslySetInnerHTML={{__html: this.state.course ? this.state.course.description as string : ''}} />
                <p><span>{'Срок выполнения '}</span>{`до ${this.state.course ? Utils.dateTimeToStr(this.state.course.deadline) : ''}`}</p>
                <h2>{'Требования к оформлению'}</h2>
                <div dangerouslySetInnerHTML={{__html: this.state.course ? this.state.course.requirements as string : ''}} />
                <h2>{'Условия/правила проведения оценивания'}</h2>
                <div dangerouslySetInnerHTML={{__html: this.state.course ? this.state.course.rankingRules as string : ''}} />
                <h2>{'Материалы задания'}</h2>
                {this.renderCourseMaterials()}
                <div></div>
                <h2>{'Критерии оценивания'}</h2>
                <div dangerouslySetInnerHTML={{__html: this.state.course ? this.state.course.markCriteria as string : ''}} />

                {
                    this.state.learningStatus === ScenarioLearningStatusString.STARTED ?
                    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '3em', marginBottom: '1em'}}>
                        <Button onClick={() => this.onPressLoadResultMaterial()}><FaFolderOpen style={{fontSize: 24, marginRight: 10}} />{'Результаты'}</Button>
                    </div> : null
                }
            </>
        );
    }

    renderAssessments = () => {
        return (
            this.state.learningStatus === ScenarioLearningStatusString.WAIT_FOR_ASSESSMENT ?
                this.state.assignedMarks.map(m => 
                <div key={m.id} style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '3em', marginBottom: '1em'}}>
                    <Button onClick={() => this.openMarkForm(m)}>{`Оценить группу ${m.group}`}</Button>
                </div>)
            : null
        );
    }

    renderLearningStatus(){
        const learningStatus = this.state.learningStatus;
        let message = '' as any;
        if (learningStatus == ScenarioLearningStatusString.UNDEFINED){
            message = "Не удалось найти курс";
        } else if (learningStatus == ScenarioLearningStatusString.FINISHED) {
            message = (
                <>
                    <p>Курс завершен: { Utils.dateTimeToStr(this.state.currentAssignment ? this.state.currentAssignment.courseCompletionDate : new Date())}</p>
                    <p>Оценка для группы ({this.state.groupId}): <b>{Utils.numberToStr(this.state.finalMark ? this.state.finalMark.finalMark : 0)}</b></p>
                    <p>Категория оценки: {(this.state.finalMark && this.state.finalMark.markCategory) ? this.state.finalMark.markCategory : 'не определена'}</p>
                    <p>
                        <Table>
                            <thead>
                                <tr>
                                    <td style={{textAlign: 'center'}}>{'Группа'}</td>
                                    <td style={{textAlign: 'center'}}>{'Оценка'}</td>
                                    <td style={{textAlign: 'center'}}>{'Категория оценки'}</td>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.finalGroupMarks.map(entry =>
                                    <tr key={entry.group}>
                                        <td style={{textAlign: 'center'}}>{entry.group}</td>
                                        <td style={{textAlign: 'center'}}>{entry.finalMark}</td>
                                        <td style={{textAlign: 'center'}}>{entry.markCategory}</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </p>
                </>
            );
            // message = `Курс завершен ${
            //     Utils.dateTimeToStr(this.state.currentAssignment ? this.state.currentAssignment.courseCompletionDate : new Date())
            // }, групповая оценка: ${
            //     this.state.finalMark ? this.state.finalMark.finalMark : 0
            // }, категория оценки: ${
            //     (this.state.finalMark && this.state.finalMark.markCategory) ? this.state.finalMark.markCategory : 'не определена'
            // }`;
        } else if (learningStatus == ScenarioLearningStatusString.WAIT_FOR_ASSESSMENT ||
            learningStatus == ScenarioLearningStatusString.WAIT_FOR_START ||
            learningStatus == ScenarioLearningStatusString.WAIT_FOR_GROUPING){
            
            message =`Дата начала курса: ${this.state.course ? Utils.dateTimeToStr(this.state.course.startDate) : ''}`;
        }
        return (
            <div style={{marginBottom: '1em'}}>
                <h3>{this.state.course ? this.state.course.name : ''}</h3>
                {message}
            </div>
        );
    }

    render() {
        // const { tabProps, selectedTabKey } = this.state;
        const learningStatus = this.state.learningStatus;
        const isRenderCourse = (learningStatus === ScenarioLearningStatusString.STARTED ||
                                learningStatus === ScenarioLearningStatusString.WAIT_FOR_ASSESSMENT);
        return (
            this.state.redirectToCourses ? (
                <Redirect to={AppRoute.COURSES} />
            ) : (
                <span>
                    <Header title={`Курс: ${this.state.course ? this.state.course.name as any : ''}`} header={this.state.groupId > 0 ? `Группа ${this.state.groupId}` : ''} />
                    {this.state.isCourseLoaded ? (
                        <>
                            <Container>
                                <Row>
                                    <Col md={6}>
                                        { isRenderCourse ? this.renderCourse() : this.renderLearningStatus() }
                                    </Col>
                                    <Col md={6}>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        {this.renderAssessments()}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={12} className='buttons-prev-next'>
                                        <ButtonToolbar className='float-right'>
                                            <Button onClick={() => this.setState({redirectToCourses: true})} variant="link" >
                                                <span>{'Перейти к выбору курса'}</span>
                                            </Button>
                                        </ButtonToolbar>
                                    </Col>
                                </Row>
                            </Container>
                            <div className='group-content'>
                                
                            </div>
                            {(learningStatus === ScenarioLearningStatusString.STARTED ||
                                learningStatus === ScenarioLearningStatusString.WAIT_FOR_ASSESSMENT) ? 
                                (<Launcher
                                    isOpen={this.state.isOpenChatWindow}
                                    agentProfile={{
                                        teamName: `Группа ${this.state.groupId}`,
                                        imageUrl: './resourses/logo.png'
                                    }}
                                    handleClick={() => this.onPressChatLauncher()}
                                    onMessageWasSent={this._onMessageWasSent.bind(this)}
                                    onScrollToTop={() => this.onScrollMessageListToTop()}
                                    newMessagesCount={this.state.chatMessageUnreadCount}
                                    messageList={this.state.messages}
                                    contactList={this.state.chatContacts}
                                    showEmoji
                                />) : null
                            }
                            <UploadResultFiles
                                ref={ref => this.uploadResultFiles = ref}
                                isVisibleButtonAdd={this.state.isResultUploader && this.state.learningStatus === ScenarioLearningStatusString.STARTED}
                                isVisibleButtonRemove={this.state.isResultUploader && this.state.learningStatus === ScenarioLearningStatusString.STARTED}
                                courseId={this.state.course ? this.state.course.id as number : 0}
                            />
                            <MarkForm ref={ref => this.markForm = ref}/>
                        </>
                    ) : null}
                </span>
            )
        );
    }
}

export default GroupTesting;